export default {
  dbl_create_dashboard_ai_analysis_entry_title: 'AI Analysis',
  dbl_ai_analysis_entry_new: 'NEW',
  dbl_ai_analysis_card_title: 'AI分析',
  dbl_ai_analysis_card_desc: '请确认',
  dbl_ai_analysis_analysis_approach: '分析方法',
  dbl_ai_analysis_generating: 'AI 分析报告正在生成中...',
  /** 报表无图表卡片时，卡片内容区提示标题 */
  dbl_ai_analysis_no_chart_title: '暂无可分析的图表',
  /** 报表无图表卡片时，卡片内容区提示说明 */
  dbl_ai_analysis_no_chart_desc: '请先添加图表',
  dbl_ai_analysis_settings_title: 'AI 分析设置',
  dbl_ai_analysis_report_preview_title: '预览 AI 分析报告',
  dbl_ai_analysis_settings_content: '设置',
  dbl_ai_analysis_report_preview_content: '报告',
  dbl_ai_analysis_preview_report: '预览报告',
  dbl_ai_analysis_back_to_settings: '返回设置',

  dbl_ai_analysis_settings_scope_label: '分析范围',
  dbl_ai_analysis_settings_scope_all_report: '整个报表',
  dbl_ai_analysis_settings_scope_tabs_label: '页签',
  dbl_ai_analysis_settings_scope_select_at_least_one_chart: '至少选择一个图表',
  dbl_ai_analysis_settings_approach_label: '分析思路',
  dbl_ai_analysis_settings_background_label: '分析背景',
  dbl_ai_analysis_settings_optional: '(可选)',
  dbl_ai_analysis_settings_custom_approach: '自定义洞察思路',
  dbl_ai_analysis_settings_custom_hint: '在此输入框中，您可以自定义输出要求和分析思路',
  dbl_ai_analysis_settings_approach_placeholder: '请输入分析思路（最多5万字符）',
  dbl_ai_analysis_settings_background_placeholder: '您可以描述游戏业务场景、核心指标及异常判定标准，帮助大模型更好的理解上下文\n例如：\n业务场景是手游的玩家留存与付费分析，需重点关注次日留存率、ARPU值和付费转化率。\n当某个渠道的次日留存率低于30%，或付费转化率环比下降超过15%时，可视为异常需要深入分析。',
  dbl_ai_analysis_settings_loading: '加载中',
  dbl_ai_analysis_settings_load_fail: '加载失败',
  dbl_ai_analysis_settings_no_data: '暂无数据',
  dbl_ai_analysis_settings_retry: '刷新',
  dbl_ai_analysis_settings_action_preview: '预览',
  dbl_ai_analysis_settings_action_save_template: '保存为模板',
  dbl_ai_analysis_settings_action_auto_apply_next_time: '下次自动应用',
  dbl_ai_analysis_settings_action_confirm: '确定',
  dbl_ai_analysis_settings_action_cancel: '取消',
  dbl_ai_analysis_template_modal_title: '保存为分析模板',
  dbl_ai_analysis_template_type_label: '模板类型',
  dbl_ai_analysis_template_type_personal: '个人模板',
  dbl_ai_analysis_template_type_game: '游戏模板',
  dbl_ai_analysis_template_type_public: '公共模板',
  dbl_ai_analysis_template_name_label: '模板名称',
  dbl_ai_analysis_template_name_placeholder: '请输入名称',
  dbl_ai_analysis_template_name_required: '请输入名称',
  dbl_ai_analysis_template_name_max_length: '长度限制 {count} 字符',
  dbl_ai_analysis_template_name_reserved:
    '默认洞察思路为系统预置名称，请修改模板名称后再保存。',
  dbl_ai_analysis_template_name_reserved_custom:
    '自定义洞察思路为系统保留名称，请修改模板名称后再保存。',
  dbl_ai_analysis_template_name_duplicate:
    '该名称已存在，保存将覆盖原有模板',
  dbl_ai_analysis_template_hint_personal: '仅本人可见，可在本人有权限的报表中应用。',
  dbl_ai_analysis_template_hint_game: '当前游戏业务内，所有用户均可应用于任意报表。',
  dbl_ai_analysis_template_hint_public: '所有业务、所有报表、所有用户均可使用。',
  dbl_ai_analysis_template_category_forbidden: '当前账号无该模板类型的设置权限',
  dbl_ai_analysis_template_save_success: '模板保存成功',
  dbl_ai_analysis_template_save_fail: '模板保存失败，请稍后重试',
  dbl_ai_analysis_settings_auto_apply_success: '已保存，下次打开将自动应用当前配置',
  dbl_ai_analysis_settings_auto_apply_fail: '保存失败，请稍后重试',
  dbl_ai_analysis_stream_default_query: '请基于当前报表输出关键洞察，并说明指标变化原因。',
  dbl_ai_analysis_stream_send: '发送',
  dbl_ai_analysis_stream_regenerate: '重新生成',
  dbl_ai_analysis_stream_stop: '停止',
  dbl_ai_analysis_stream_clear: '清空',
  dbl_ai_analysis_stream_empty: '暂无流式输出内容',
  dbl_ai_analysis_stream_parse_error: '流式数据解析失败',
  dbl_ai_analysis_stream_state_idle: '状态：待发送',
  dbl_ai_analysis_stream_state_pending: '状态：连接中',
  dbl_ai_analysis_stream_state_progressing: '状态：分析中',
  dbl_ai_analysis_stream_state_complete: '状态：已完成',
  dbl_ai_analysis_stream_state_rejected: '状态：已中断',
  dbl_ai_analysis_filter_change_tip_prefix: '当前报表数据已更新，点击',
  dbl_ai_analysis_filter_change_tip_action: '刷新',
  dbl_ai_analysis_filter_change_tip_suffix: '重新生成洞察分析',
  dbl_ai_analysis_stream_background_prefix: '业务背景：',
  dbl_ai_analysis_apply_and_exit: '应用并退出',
};

